<div class="grid-container padding-y-1">
  <fieldset class="usa-fieldset">
    <div class="grid-row grid-gap-1">
      @if (accessorialsCalledFrom != 'frtBOL') {
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          @if (!redirectedFromBol) {
            <legend class="usa-legend usa-legend--medium">
              Freight Accessorial Service Charges
            </legend>
          }
        </div>
      }
    </div>
    <div class="grid-row grid-gap-1">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        @if (!redirectedFromBol) {
          <label class="usa-label text-bold">Book Shipment Id - {{bookShipmentId}}</label>
        }
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <form id="frtShipmentAccessorialForm" [formGroup]="frtShipmentAccessorialForm">
          <div class="grid-row grid-gap-1">
            @if (this.isOneTimeShipment === 'false') {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                @if (zeroAccessorialCount) {
                  <label class="usa-label text-bold">Please add/update accessorials</label>
                }
                @if (!redirectedFromBol && !isCarrierView) {
                  <button type="button" class="usa-button" (click)="addAccessorial()">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#add"></use>
                    </svg> Accessorial
                  </button>
                }
              </div>
            }
            @for (accessorial of frtShipmentAccessorialForm.get('accessorials')['controls']; track accessorial; let i = $index) {
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" formArrayName="accessorials">
                <div class="grid-row grid-gap-1" [formGroupName]="i">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                    <label for="accessorial_{{i}}" class="usa-label text-bold">Accessorial {{i+1}}</label>
                    <select id="accessorial_{{i}}" formControlName="accessorial" class="usa-select maxw-full" (change)="onAccessorialChange($event, i)">
                      <option [ngValue]="null" selected disabled>Choose...</option>
                      @for (accessorial of accessorialList; track accessorial) {
                        <option [ngValue]="accessorial">{{accessorial.accessorialCode}} - {{accessorial.accessorialDescription}}</option>
                      }
                    </select>
                  </div>
                  @if (this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].unitDescription.value !== null) {
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                      <!-- <span > -->
                      <label class="usa-label text-bold">{{this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].unitDescription.value}}</label>
                      <input type="text" id="units_1_{{i}}" formControlName="units" name="units" class="maxw-full usa-input" (blur)="onShipAuthorizationChange(i)">
                      @if (this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].units.touched &&
                        this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].units.hasError('numeric')) {
                        <div class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> Units should contain only numbers
                        </div>
                      }
                    <!-- </span> -->
                  </div>
                }
                @if (isOneTimeShipment != 'true') {
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                    <label for="ship_auth_{{i}}" class="usa-label text-bold">Shipper Authorization</label>
                                    <select id="ship_auth_{{i}}" formControlName="shipAuthorize" class="usa-select maxw-full" [attr.disabled]="(this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].tspAuthorize.value === '' ||
                                        this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].tspAuthorize.value === null || isCarrierView)?true:null">
                      <option value=null selected>None</option>
                      @for (saList of shipperAuthorization; track saList) {
                        <option [value] = "saList">{{saList}}</option>
                      }
                    </select>
                  </div>
                }
                @if (isOneTimeShipment != 'true') {
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                    <label for="tsp_acc_{{i}}" class="usa-label text-bold">TSP Acceptance</label>
                    <select id="tsp_acc_{{i}}" class="maxw-full usa-select" [attr.disabled]="isCarrierView?null:true" formControlName="tspAuthorize">
                      <option value=null selected>None</option>
                      @for (tspList of tspAuthorization; track tspList) {
                        <option [value]="tspList">
                        {{tspList}}</option>
                      }
                    </select>
                  </div>
                }
                @if (!isUnitsIdNine) {
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                    <label class="usa-label text-bold" for="acc_amount_{{i}}">Amount</label>
                    <input type="text" id="acc_amount_{{i}}" formControlName="amount" name="amount" class="maxw-full usa-input">
                    @if (this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].amount.touched &&
                      this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].amount.hasError('required')) {
                      <div class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> Amount is required
                      </div>
                    }
                    @if (this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].amount.touched &&
                      this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].amount.hasError('min')) {
                      <div class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> Amount should be greater than zero
                      </div>
                    }
                    @if (this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].amount.touched &&
                      this.frtShipmentAccessorialForm.get('accessorials')['controls'][i]['controls'].amount.hasError('currency')) {
                      <div class="define-text-secondary">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                          <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                        </svg> Amount should contain only numbers and decimals upto 2 digits
                      </div>
                    }
                  </div>
                }
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                  <label for="add_info_{{i}}" class="usa-label">Message</label>
                  <button type="button" class="usa-button maxw-full" id="add_info_{{i}}" (click)="openAdditionalInfo(i)" [disabled]="(this.frtShipmentAccessorialForm.get('accessorials').at(i).get('accessorial')?.value == null)? true: false">Notes</button>
                </div>
                <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
                  @if (!redirectedFromBol && !isCarrierView) {
                    <button type="button" class="usa-button usa-button--secondary" (click)="removeAccessorial(i, this.frtShipmentAccessorialForm.get('accessorials').at(i).get('accessorial')?.value)">
                      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                        <use xlink:href="/assets/uswds/img/sprite.svg#delete"></use>
                      </svg>Delete
                    </button>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        <div class="grid-row grid-gap-1 padding-top-4">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <ng-container>
              @if (showAccessorialsError) {
                <div class="define-text-secondary">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Please delete duplicate accessorials to proceed.
                </div>
              }
            </ng-container>
            @if (!redirectedFromBol) {
              <button type="button" class="usa-button" [disabled]="!frtShipmentAccessorialForm.valid || showAccessorialsError" (click)="saveAccessorial()">Save</button>
            }
            @if (!redirectedFromBol) {
              <button type="button" class="usa-button usa-button--outline" (click)="goBack()">Back</button>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
</fieldset>

</div>
